import { createApp } from "vue";
import App from "@/App.vue";
import router from "@/router";
import store from "@/store";
import "@fortawesome/fontawesome-free/css/all.min.css";
import apiWrapperPlugin from '@/plugins/api-wrapper';
import CookieConsentController from "@/plugins/cookieconsent-controller";
import log from "@/utils/logger";
import VModal from "@/components/UI/VModal";
import VueGtag from "vue-gtag";

log.info("Current environment: %s", process.env.NODE_ENV);

const app = createApp(App)
    .use(router)
    .use(store)
    .use(apiWrapperPlugin, { store })
    .use(VueGtag, {
        config: {
            id: "G-3REW79YEBZ",
            params: {
                anonymize_ip: true
            }
        },
        router,
        enabled: false
    });

app.provide("gtag", app.config.globalProperties.$gtag);

app.use(CookieConsentController);
app.component("v-modal", VModal);

app.directive("hover", {
    beforeMount(el, binding)
    {
        if (typeof binding.value !== "function")
        {
            console.warn("v-hover expects a function");
            return;
        }

        // Ensure the element itself receives events
        el.style.position = el.style.position || "relative";

        const enter = () => binding.value(true);
        const leave = () => binding.value(false);

        el.__enter__ = enter;
        el.__leave__ = leave;

        // Use pointerenter/pointerleave instead of mouseenter/mouseleave
        // These work better with buttons and nested elements
        el.addEventListener("pointerenter", enter);
        el.addEventListener("pointerleave", leave);
    },

    unmounted(el)
    {
        el.removeEventListener("pointerenter", el.__enter__);
        el.removeEventListener("pointerleave", el.__leave__);
    }
});



app.mount('#app');